"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertParticipantResponsesWithDataSources = void 0;
function assertParticipantResponsesWithDataSources(handleSubmissionMock, responses, participants) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(3);
    var supervisorResponse = responses.find(function (r) { return r.questionId === 1200001; });
    expect(supervisorResponse.answer).toBe("A PARCHURE");
    expect(supervisorResponse.associatedId).toBe(1075001);
    expect(supervisorResponse.associatedRootId).toBeUndefined();
    expect(supervisorResponse.questionId).toBe(1200001);
    expect(supervisorResponse.questionRootId).toBe(1175952);
    expect(typeof supervisorResponse.timeAnswered).toBe("string");
    var attendant1Response = responses.find(function (r) { return r.answer === "A Cassada"; });
    expect(attendant1Response.associatedId).toBe(33985);
    expect(attendant1Response.associatedRootId).toBeUndefined();
    expect(attendant1Response.questionId).toBe(1200151);
    expect(attendant1Response.questionRootId).toBe(1200151);
    expect(typeof attendant1Response.timeAnswered).toBe("string");
    var attendant2Response = responses.find(function (r) { return r.answer === "A Powell"; });
    expect(attendant2Response.associatedId).toBe(43264);
    expect(attendant2Response.associatedRootId).toBeUndefined();
    expect(attendant2Response.questionId).toBe(1200151);
    expect(attendant2Response.questionRootId).toBe(1200151);
    expect(typeof attendant2Response.timeAnswered).toBe("string");
    expect(participants.length).toBe(3);
    var supervisorParticipant = participants.find(function (p) { return p.participantId === 1075001; });
    expect(supervisorParticipant.name).toBe("A PARCHURE");
    expect(supervisorParticipant.role).toBe("SUPERVISOR");
    expect(typeof supervisorParticipant.timeAdded).toBe("string");
    expect(supervisorParticipant.signatureType).toBe("TYPED");
    expect(supervisorParticipant.signatureTextValue).toBe("abhineet.h.parchure@dominionenergy.com");
    expect(typeof supervisorParticipant.signatureDate).toBe("string");
    var attendant1Participant = participants.find(function (p) { return p.participantId === 33985; });
    expect(attendant1Participant.name).toBe("A Cassada");
    expect(attendant1Participant.role).toBe("ATTENDANT");
    expect(typeof attendant1Participant.timeAdded).toBe("string");
    expect(attendant1Participant.signatureType).toBe("TYPED");
    expect(attendant1Participant.signatureTextValue).toBe("brian.cassada@dominionenergy.com");
    expect(typeof attendant1Participant.signatureDate).toBe("string");
    var attendant2Participant = participants.find(function (p) { return p.participantId === 43264; });
    expect(attendant2Participant.name).toBe("A Powell");
    expect(attendant2Participant.role).toBe("ATTENDANT");
    expect(typeof attendant2Participant.timeAdded).toBe("string");
    expect(attendant2Participant.signatureType).toBe("TYPED");
    expect(attendant2Participant.signatureTextValue).toBe("al-nasir.a.powell@dominionenergy.com");
    expect(typeof attendant2Participant.signatureDate).toBe("string");
}
exports.assertParticipantResponsesWithDataSources = assertParticipantResponsesWithDataSources;
//# sourceMappingURL=participantResponses.js.map